import * as Sentry from '@sentry/react';

import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import createAction from './';
import * as services from '../services/externalLogin';
import { TOS_NEED_APPROVE } from './termsOfService';
import { LOGOUT } from './logout';
import { setDeepLink } from '../../common/actions/deepLink';
import { setRouteToRedirect } from './redirect';

export const EXTERNAL_LOGIN = createAsyncAction(createAction('EXTERNAL_LOGIN'));

export const externalLogin = (token) => (dispatch) => {
  dispatch({ type: EXTERNAL_LOGIN.pending });

  const apiCallParams = {
    mutation: services.EXTERNAL_LOGIN,
    variables: {
      externalToken: token,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { externalLogin } }) => {
      const { externalId, orgId, tosRequired, token: tosToken, jwt, refreshToken } = externalLogin;
      Sentry.configureScope((scope) => {
        scope.setUser({ 'policyId': externalId });
      });

      dispatch(setDeepLink());

      if (tosRequired) {
        return dispatch({
          type: TOS_NEED_APPROVE,
          payload: {
            tosRequired,
            tosToken,
            orgId,
            externalId,
          },
        });
      }

      dispatch({ type: LOGOUT.success, payload: { skipRedirect: true } });
      dispatch({
        type: EXTERNAL_LOGIN.success,
        payload: { jwtToken: jwt, refreshToken },
      });
    })
    .catch((err) => {
      dispatch({ type: LOGOUT.success });
      dispatch(errorAction(EXTERNAL_LOGIN.failure, err));
    });
};

export const externalJwtLogin = (jwtToken) => (dispatch) => {
  localStorage.setItem('jwt', jwtToken);

  dispatch({ type: LOGOUT.success, payload: { skipRedirect: true } });
  dispatch(setRouteToRedirect('/external-conference'));
  dispatch({
    type: EXTERNAL_LOGIN.success,
    payload: { jwtToken, refreshToken: null },
  });
};
